<div class="error-header">
  <img src="assets/images/MatrixCare_Logo.png" class="mxc-logo" alt="MatrixCare Logo" />
</div>

<div class="row" style="margin-top:70px;">
  <div class="col" style="text-align:right">
    <img src="assets/images/doctor.png" style="width:320px;margin-right:20px" />
  </div>
  <div class="col" style="  margin-left:20px; ">
    <div class="card-img-overlay d-flex justify-content-center  flex-column">
      <div style="font-size:40px; font-weight:bold">No Permissions</div><br />
      <div style="font-size:20px">
        <div>Error Code: 403</div><br />
        <div>Looks like you do not have permission to access any pages here. Please contact your system administrator if you feel this is an error.</div><br />
        <div><a href="javascript:void()" style="text-decoration:none" (click)="goBack()"><span class="fa fa-arrow-left" style="margin-right:10px"></span>Back to previous page</a></div>
      </div>
    </div>
  </div>
</div>


